import { Home } from "../pages";
import Cooperatives from "../pages/Admin/Cooperatives";
import CreateCooperativePage from "../pages/Admin/CreateCooperativePage";
import TransactionHistoryPage from "../pages/Admin/TransactionHistoryPage";
import SettlementPage from "../pages/Admin/Settlement/SettlementPage";
import CooperativeDetailsPage from "../pages/Admin/Cooperatives/CooperativeDetailsPage";
import Subscriptions from "../pages/Admin/Subscriptions";
import SubscriptionsDetails from "../pages/Admin/Subscriptions/SubscriptionsDetails";
import Modules from "../pages/Admin/Modules";
import Messaging from "../pages/Admin/Messaging";
import TopUpOrders from "../pages/Admin/Messaging/Orders";
import MessagingProvidersSettings from "../pages/Admin/Messaging/MessagingProvidersSettings";
import PlatformSmsPricing from "../pages/Admin/Messaging/PlatformSmsPricing";
import SmsDeliveryHistory from "../pages/Admin/Messaging/SmsDeliveryHistory";
import ProfilePage from "../pages/Admin/Profile";
import RegistrationApplicationsList from "../pages/Admin/RegistrationApplications/RegistrationApplicationsList";
import DemoRequestsList from "../pages/Admin/DemoRequests/DemoRequestsList";
import ContactSubmissionsList from "../pages/Admin/ContactSubmissions/ContactSubmissionsList";

export const routeList = [
  {
    children: [
      {
        component: Home,
        exact: true,
        name: "Home",
        path: "/dashboard",
        protected: false,
      },
    ],
    component: Home,
    exact: true,
    name: "Home",
    // path: "/",
    protected: false,
  },
  {
    component: Cooperatives,
    exact: true,
    name: "Cooperatives",
    path: "/cooperatives",
    protected: false,
  },
  {
    component: RegistrationApplicationsList,
    exact: true,
    name: "Get Started applications",
    path: "/registration-applications",
    protected: false,
  },
  {
    component: DemoRequestsList,
    exact: true,
    name: "Demo requests",
    path: "/demo-requests",
    protected: false,
  },
  {
    component: ContactSubmissionsList,
    exact: true,
    name: "Contact messages",
    path: "/contact-submissions",
    protected: false,
  },
  {
    component: CooperativeDetailsPage,
    exact: true,
    name: "Cooperative Details",
    path: "/cooperatives/:id",
    protected: false,
  },
  {
    component: CreateCooperativePage,
    exact: true,
    name: "Create Cooperative",
    path: "/cooperatives/create",
    protected: false,
  },
  {
    component: TransactionHistoryPage,
    exact: true,
    name: "Transaction history",
    path: "/transaction-history",
    protected: false,
  },
  {
    component: SettlementPage,
    exact: true,
    name: "Settlement & fees",
    path: "/settlement",
    protected: false,
  },
  {
    component: Subscriptions,
    exact: true,
    name: "Subscriptions",
    path: "/subscriptions",
    protected: false,
  },
  {
    component: SubscriptionsDetails,
    exact: true,
    name: "Subscriptions Details",
    path: "/subscriptions/:id",
    protected: false,
  },
  {
    component: Modules,
    exact: true,
    name: "Modules",
    path: "/modules",
    protected: false,
  },
  {
    children: [
      {
        component: TopUpOrders,
        name: "Top Up Orders",
        path: "top_up_orders",
        protected: false,
      },
      {
        component: MessagingProvidersSettings,
        name: "Messaging providers",
        path: "messaging-providers",
        protected: false,
      },
      {
        component: PlatformSmsPricing,
        name: "Platform SMS pricing",
        path: "platform-sms-pricing",
        protected: false,
      },
      {
        component: SmsDeliveryHistory,
        name: "SMS delivery log",
        path: "delivery-log",
        protected: false,
      },
    ],
    component: Messaging,
    name: "Messaging",
    path: "/sms-messaging/*",
    protected: false,
  },
  {
    component: ProfilePage,
    exact: true,
    name: "Profile",
    path: "/profile",
    protected: false,
  },
];
